import { put, select, takeLatest } from 'redux-saga/effects';
import { axiosInstance } from '../../config/axios';
import { apiEndpoints } from '../../utils/api-endpoints';
import { createErrorAction } from '../reducers/errorSlice';
import {
    getErrorLogsSuccess,
    getErrorLogsFailed,
    dismissErrorLogSuccess,
    dismissErrorLogFailed,
    dismissAllErrorLogsSuccess,
    dismissAllErrorLogsFailed,
    getErrorLogs
} from '../reducers/errorLogSlice';
import { selectErrorLogsSelector } from '../selectors/errorLogSelector';

function* getErrorLogsSaga(action: { type: string; payload?: { page?: number; per_page?: number } }): any {
    try {
        const current = yield select(selectErrorLogsSelector);
        const params = {
            page: action.payload?.page || current.page || 1,
            per_page: action.payload?.per_page || current.per_page || 10
        };
        const response = yield axiosInstance.get(apiEndpoints.errorLogs.list, { params });
        yield put(getErrorLogsSuccess(response?.data || { data: [], total: 0, ...params }));
    } catch (error) {
        yield put(getErrorLogsFailed());
        yield put(createErrorAction(error, 'errorLog/getErrorLogs'));
    }
}

function* dismissErrorLogSaga(action: { type: string; payload: string }): any {
    try {
        yield axiosInstance.post(apiEndpoints.errorLogs.dismiss(action.payload));
        yield put(dismissErrorLogSuccess());
        const { page, per_page, total } = yield select(selectErrorLogsSelector);
        const remaining = Math.max(0, Number(total || 0) - 1);
        const lastPage = Math.max(1, Math.ceil(remaining / (per_page || 10)));
        yield put(getErrorLogs({ page: Math.min(page || 1, lastPage), per_page }));
    } catch (error) {
        yield put(dismissErrorLogFailed());
        yield put(createErrorAction(error, 'errorLog/dismissErrorLog'));
    }
}

function* dismissAllErrorLogsSaga(): any {
    try {
        yield axiosInstance.post(apiEndpoints.errorLogs.dismissAll);
        yield put(dismissAllErrorLogsSuccess());
    } catch (error) {
        yield put(dismissAllErrorLogsFailed());
        yield put(createErrorAction(error, 'errorLog/dismissAllErrorLogs'));
    }
}

export function* watchErrorLogSaga() {
    yield takeLatest('errorLog/getErrorLogs', getErrorLogsSaga);
    yield takeLatest('errorLog/dismissErrorLog', dismissErrorLogSaga);
    yield takeLatest('errorLog/dismissAllErrorLogs', dismissAllErrorLogsSaga);
}
